// ======================================================================
// File Name       : enterprise
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import { MODE, USAGE_SETTING, DORMANT_STATE } from '../constants';
import {
  ENTERPRISE_RECEIVE_GET_STRUCTURE,
  ENTERPRISE_INIT_EDIT,
  ENTERPRISE_INIT_REGISTER,
  ENTERPRISE_UPDATE,
  ENTERPRISE_USAGE_INFO_UPDATE,
  ENTERPRISE_SAVE_REASON,
} from '../constants/actionTypes/enterprise';
import { convertListToObjectByEnterpriseCd, setEnterpriseRelation } from '../utils/EnterPriseUtils';
import { PRICE_PLAN } from '../constants/EnterpriseConstants';

const INIT_ENTERPRISE = {
  enterpriseCd: null,
  enterpriseName: null,
  usageSettingInfo: {
    usageSettingDrill: USAGE_SETTING.USE,
    usageSettingDocument: USAGE_SETTING.USE,
    usageSettingLrs: USAGE_SETTING.USE,
    usageSettingVideo: USAGE_SETTING.USE,
    usageSettingLive: USAGE_SETTING.UN_USE,  //STEP12.1.0 TAS-16386
  },
  parentEnterpriseInfo: {
    parentEnterpriseCd: null,
  },
  dormantState: DORMANT_STATE.ACTIVE,
  unitPriceSettingInfo: {},
};

const INITIAL_STATE = {
  enterprises: {
    recordNum: 0,
    bySecernId: {},
    allSecernIds: [],
  },

  editMode: MODE.EDIT_MODE,
  editingEnterprise: {},

  enterpriseStructure: [],
  enterpriseId: null,
  enterpriseCd: null,
  enterpriseImport: {
    recordNum: 0,
    importResultList: [],
  },
};

export default function course(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ENTERPRISE_RECEIVE_GET_STRUCTURE:
      return receiveStructureList(state, action);

    case ENTERPRISE_INIT_EDIT:
      return initEdit(state, action);

    case ENTERPRISE_INIT_REGISTER:
      return initRegister(state, action);

    case ENTERPRISE_UPDATE:
      return { ...state, editingEnterprise: { ...state.editingEnterprise, ...action.payload }, isDetail: false};

    case ENTERPRISE_USAGE_INFO_UPDATE:
      return updateUsageInfo(state, action);

    case ENTERPRISE_SAVE_REASON:
      return saveEnterpriseReason(state, action);

    default:
      return state;
  }
}

function receiveStructureList(state, action) {
  const { recordNum, enterpriseList } = action;
  const newState = enterpriseList.reduce(
    (acc, cur) => {
      const { enterpriseCd, parentEnterpriseInfo } = cur;
      const { parentEnterpriseCd } = parentEnterpriseInfo || {};
      cur.child = (acc.enterprises.bySecernId[enterpriseCd] || {}).child || [];
      setEnterpriseRelation(acc.enterprises, enterpriseCd, parentEnterpriseCd);
      return acc;
    },
    {
      enterprises: {
        recordNum,
        bySecernId: convertListToObjectByEnterpriseCd(enterpriseList),
        allSecernIds: [],
      },
    },
  );

  // Step 12.0.0 TAS-18710 START
  const isEnterpriseNotChild = Object.keys(enterpriseList).length === 1;
  if (enterpriseList && isEnterpriseNotChild) {
    newState.editingEnterprise = newState.enterprises.bySecernId[Object.keys(newState.enterprises.bySecernId)[0]];
    newState.isEnterpriseNotChild = isEnterpriseNotChild;
  }
  // Step 12.0.0 TAS-18710 END

  return {
    ...state,
    ...newState,
    enterpriseStructure: enterpriseList,
  };
}

function initEdit(state, action) {
  const { enterpriseCd, pricePlan } = action;
  const selectedEnterprise = { ...state.enterprises.bySecernId[enterpriseCd] };
  selectedEnterprise.usageSettingInfo.pricePlan =
    selectedEnterprise.usageSettingInfo.pricePlan === undefined ? PRICE_PLAN.OLD : pricePlan;
  const newState = {
    editMode: MODE.EDIT_MODE,
    editingEnterprise: selectedEnterprise,
    orgPricePlan: selectedEnterprise.usageSettingInfo.pricePlan,
    isDetail: true,
  };

  return {
    ...state,
    ...newState,
  };
}

function initRegister(state, action) {
  const parentInfoData = action.parentInfoData;
  const { enterpriseCd, enterpriseLayer, pricePlan, pricePlanUpdateReservedFlag } = parentInfoData;
  const initEnterprise = $.extend(true, {}, INIT_ENTERPRISE);
  const newState = {
    editMode: MODE.NEW_MODE,
    editingEnterprise: {
      ...initEnterprise,
      parentEnterpriseInfo: {
        parentEnterpriseCd: enterpriseCd,
        parentEnterpriseLayer: enterpriseLayer,
        parentPricePlan: pricePlan === undefined ? PRICE_PLAN.OLD : pricePlan,
        parentPricePlanUpdateReservedFlag: pricePlanUpdateReservedFlag,
      },
      isConfirm: false,
    },
  };
  return {
    ...state,
    ...newState,
  };
}

function updateUsageInfo(state, action) {
  const { usageSettingInfo } = action;
  const { editingEnterprise } = state;
  editingEnterprise.usageSettingInfo = usageSettingInfo;
  const newState = {
    ...state,
    editingEnterprise,
  };

  return {
    ...state,
    ...newState,
  };
}

function saveEnterpriseReason(state, action) {
  const {  payload } = action;
  return {
    ...state,
    enterpiseReason: payload,
  }
}
